import { Card, List, ListItem, ListItemPrefix, Typography } from "@material-tailwind/react";
import { motion } from "framer-motion";
import React, { FC, useEffect, useState } from "react";
import { HiOutlineNewspaper } from "react-icons/hi2";
import { Link, useLocation } from "react-router-dom";

export interface DashboardMenuCreatorProps {
  children?: React.ReactNode;
}

const DashboardMenuCreator: FC<DashboardMenuCreatorProps> = ({ children }) => {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState<string | null>(location.pathname);

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen lg:flex-row bg-neutral-50 dark:bg-neutral-900">
      <motion.div
        transition={{ duration: 1 }}
        className="p-4 border-r shadow-lg lg:p-6 lg:w-80 border-neutral-200 dark:border-neutral-700 dark:bg-gray-800"
      >
        <Card className="w-full h-full p-4 overflow-auto dark:bg-gray-800 scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200">
          <div className="p-4 mb-4">
            <Typography variant="h5" color="blue-gray" className="dark:text-white">
              Bienvenue
            </Typography>
          </div>
          <List>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <ListItem
                className={`p-0 ${location.pathname === "/dashboard-creator" ? "font-bold bg-blue-50 dark:bg-blue-900" : ""}`}
              >
                <Link to="/dashboard-creator" className="flex items-center w-full p-3 dark:text-white">
                  <ListItemPrefix>
                    <HiOutlineNewspaper className="w-6 h-6 mr-2" />
                  </ListItemPrefix>
                  Mes Articles
                </Link>
              </ListItem>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <ListItem
                className={`p-0 ${location.pathname === "/dashboard/add-article" ? "font-bold bg-blue-50 dark:bg-blue-900" : ""}`}
              >
                <Link to="/dashboard/add-article" className="flex items-center w-full p-3 dark:text-white">
                  <ListItemPrefix>
                    <HiOutlineNewspaper className="w-6 h-6 mr-2" />
                  </ListItemPrefix>
                  Ajouter Article
                </Link>
              </ListItem>
            </motion.div>
          </List>
        </Card>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="flex-1 p-4 lg:p-8"
      >
        {children}
      </motion.div>
    </div>
  );
};

export default DashboardMenuCreator;
